componentRegistryInstance.register('progress', 'read', 'hrd.components.form.ProgressComponent');

hrd.components.form.ProgressComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.ProgressComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, klass);
		field.progressbar({
			value: false,
		});
	},
	getReadOnlyField: function(field, name, object, options) {
		// do nothing
	},
	setReadOnlyField: function(field, value, object, options) {
		if(value !== undefined){
			var dataLabel = field.data('label') || field.data('progressLabel')
			var label = this.getValueByPath(object, dataLabel);
			field.show().progressbar("value", value).progressbar("label", label);
		}
	},
	resetReadOnlyField: function(field, options) {
		field.progressbar("value", false).progressbar("label", '');
	}
});